module.exports = __webpack_public_path__ + "static/media/Babysitters (1).5eda6433.png";